import React, { createContext, useContext, useState } from "react";

const DashboardReadyContext = createContext();

export function DashboardReadyProvider({ children }) {
  const [ready, setReady] = useState(false);
  return (
    <DashboardReadyContext.Provider value={{ ready, setReady }}>
      {children}
    </DashboardReadyContext.Provider>
  );
}

export const useDashboardReady = () => useContext(DashboardReadyContext);